export const blockIconsBusinessandpaymentsStorefrontNew = (
	<span className='material-symbols-outlined'>storefront</span>
);
